/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2023-02-13 15:00:00
 *
 *******************************************************/
// @flow

import React, { Component } from 'react';
import { Modal, Link, Button, Icon } from '@shopify/polaris';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';
import { URL } from 'src/constants/links';
import {
  MobileCancelMajor
} from '@shopify/polaris-icons';

type Props = {
  active: boolean,
  removing: boolean,
  handleClose: () => void,
  handleContinue: () => void
};

type ComposedProps = Props & WithI18nProps;

class RevertThemeAllFeatureChoosingModal extends Component<ComposedProps> {
  render() {
    const { i18n, active } = this.props;

    return (
      <Modal
        large
        titleHidden
        open={active}
        onClose={this.handleClose}
        >
        <Modal.Section>
          <div className='revert-theme-all-feature-choosing-heading'>
            <div className='heading'>{i18n.translate('AdminHTML.ThemeRevert.ConfirmRevertThemeModalV2.heading')}</div>
            <div className='hint'>{i18n.translate('AdminHTML.ThemeRevert.ConfirmRevertThemeModalV2.hint')}</div>
            <div className="close" onClick={this.handleClose}>
              <Icon
                source={MobileCancelMajor}
                color="base"
              />
            </div>
          </div>
          <div className="revert-theme-all-feature-choosing-content">
            <div className="manual-uninstallation">
              <div className="content">
                <div className="title">{i18n.translate('AdminHTML.ThemeRevert.ConfirmRevertThemeModalV2.manual_title')}</div>
                <p>{i18n.translate('AdminHTML.ThemeRevert.ConfirmRevertThemeModalV2.manual_content1', {
                  t: <Link external url={URL['ThemeRevertManualInstruction']}>{i18n.translate('AdminHTML.ThemeRevert.ConfirmRevertThemeModalV2.manual_content1_t')}</Link>
                })}</p>
                <p>{i18n.translate('AdminHTML.ThemeRevert.ConfirmRevertThemeModalV2.manual_content2')}</p>
              </div>
              <div><Button onClick={this.handleRevertContactOurTeam}>{i18n.translate('AdminHTML.ThemeRevert.ConfirmRevertThemeModalV2.manual_btn')}</Button></div>
            </div>
            <div className="automatic-uninstallation">
              <div className="content">
                <div className="title">{i18n.translate('AdminHTML.ThemeRevert.ConfirmRevertThemeModalV2.automatic_title')}</div>
                <p>{i18n.translate('AdminHTML.ThemeRevert.ConfirmRevertThemeModalV2.automatic_content1')}</p>
                <p>{i18n.translate('AdminHTML.ThemeRevert.ConfirmRevertThemeModalV2.automatic_content2')}</p>
              </div>
              <div><Button destructive onClick={this.handleRevert}>{i18n.translate('AdminHTML.ThemeRevert.ConfirmRevertThemeModalV2.automatic_btn')}</Button></div>
            </div>
          </div>
        </Modal.Section>
      </Modal>
    );
  }

  handleClose = () => {
    this.props.handleClose();
  };

  handleContinue = () => {
    const { handleContinue, data } = this.props;

    handleContinue(data);
  };
  
  handleRevert = () => {
    this.props.handleRevert();
  }

  handleRevertContactOurTeam = () => {
    this.props.handleRevertContactOurTeam();
  }
}

export default withI18n()(RevertThemeAllFeatureChoosingModal);
